import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_COREOrderForServicesMD = ({ itemsRef, showErrorFor }) => {

    return <form id='GHP_COREOrderForServicesMD' className='file-pdf-document'>
        <div className='file-template'>


            <table>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Start Date</span>
                        <input type='date' id="txtStartDate" name="txtStartDate" className='add-only' />
                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>End Date</span>
                        <input type='date' id="txtEndDate" name="txtEndDate" className='add-only' />
                    </td>

                </tr>
            </table>


            <p>
                Based upon the Comprehensive (Biopsychosocial) Assessment and/or other relevant information, I order for the Individual to receive the following checked services: </p>

            <h4>Only check services that are being provided</h4>

            <table>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'>Medical Order:
                            (Physician/APRN Only)</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="cbMedicalOrder_1" name="cbMedicalOrder_1" className='add-only' value="MedicalOrder_1" /> Diagnostic Assessment (MD Only)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="cbMedicalOrder_2" name="cbMedicalOrder_2" className='add-only' value="MedicalOrder_2" /> Psychiatric Care/Physician Assessment (MD Only)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="cbMedicalOrder_3" name="cbMedicalOrder_3" className='add-only' value="MedicalOrder_3" /> Nursing Assessment/Health Services (MD Only)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="cbMedicalOrder_4" name="cbMedicalOrder_4"
                            className='add-only' value="MedicalOrder_4" /> Medication Administration (MD Only)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="cbMedicalOrder_5" name="cbMedicalOrder_5"
                            className='add-only' value="MedicalOrder_5" /> Psychological Testing
                    </td>
                    <td className='w-375'>
                        &nbsp;
                    </td>
                </tr>
            </table>

            <h4>The above Medical Orders have been order by:</h4>

            <table>
                <tr>
                    <td className=' signature w-300'>&nbsp;</td>
                    <td className=' signature w-75'>&nbsp;</td>
                    <td className=' signature w-250'>&nbsp;</td>
                    <td className=' signature w-75'>&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75 pr-3"> License #</td>
                    <td className="small w-300 pr-3"> Licensed Professional  signature and Credentials </td>
                    <td className="small w-75 pr-3"> Date</td>
                </tr>
                <tr>
                    <td className=' signature w-300'>&nbsp;</td>
                    <td className=' signature w-75'>&nbsp;</td>
                    <td className=' signature w-250'>&nbsp;</td>
                    <td className=' signature w-75'>&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75 pr-3"> License #</td>
                    <td className="small w-300 pr-3"> Licensed Professional  signature and Credentials </td>
                    <td className="small w-75 pr-3"> Date</td>
                </tr>
            </table> 


        </div>
    </form >
}